import React, { useState } from 'react';
import styled from 'styled-components';
import LineLimitedText from '~/components/LineLimitedText';

// Note: Was hoping to make this a shared component but there are multiple versions
// of it already... Leaving as is until discussed with the team at large.
export const ConcealerButton = styled.button.attrs(({
  // For accessibility & the eslint rule react/button-has-type
  type: 'button',
}))`
  /* This is so the button is on it's own line always */
  display: block;

  /* Undo the base styles */
  border: none;
  background: none;
  padding: 0;
  font-weight: 400;

  /* Style to look like a link */
  color: var(--cl-juicyBlue-600);
  text-decoration: underline;
`;

export interface TextConcealerProps {
  /** The text you want to conceal after a certain amount of chars */
  text: string;
  /** This is to allow this component to be restyled by styled-components */
  className?: string;
}

/**
 * A component to show a subset of some text and provide a more/less button
 * to show/hide the excess content.
 */
const TextConcealer = ({ text, className }: TextConcealerProps) => {
  const [showAllText, setShowAllText] = useState(false);

  if (showAllText) {
    return (
      <p className={className}>
        {text}
        <ConcealerButton onClick={() => setShowAllText(false)}>
          less
        </ConcealerButton>
      </p>
    );
  }

  return (
    <p className={className}>
      <LineLimitedText>{text}</LineLimitedText>
      <ConcealerButton onClick={() => setShowAllText(true)}>
        more
      </ConcealerButton>
    </p>
  );
};

export default TextConcealer;
